export default __webpack_public_path__ + "static/media/wizard.64cb9f09.svg";